import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { makeStyles } from 'utils/styles';
import PropTypes from 'prop-types';
import React from 'react';
import theme from 'source/theme';

const useStyles = makeStyles({
  dialogTitle: {
    backgroundColor: theme.palette.background.veryLight,
    color: theme.palette.secondary.dark
  },
  dialogActions: {
    backgroundColor: theme.palette.background.veryLight
  },
  dialogContent: {
    padding: 0
  },
  paper: {
    width: '80%',
    maxHeight: '60%'
  }
});

const Component = props => {
  const { header, maxWidth, noContentPadding, onClose, onConfirm, open } = props;
  const classes = useStyles();

  return (
    <Dialog
      maxWidth={maxWidth}
      // onEntering={handleEntering}
      aria-labelledby="confirmation-dialog-title"
      open={open}
      classes={{ paper: classes.paper }}
      //keepMounted
    >
      <DialogTitle className={classes.dialogTitle}>{header}</DialogTitle>
      <DialogContent dividers className={noContentPadding ? classes.dialogContent : null}>
        {props.children}
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button autoFocus onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="secondary">
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

Component.propTypes = {
  header: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  maxWidth:  PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs', false]),
  noContentPadding: PropTypes.bool
};

export default Component;
